import { setup, setupCache, serializeQuery } from './api'
import RedisStore from './redis'

export { setup, setupCache, serializeQuery, RedisStore }
export default { setup, setupCache, serializeQuery, RedisStore }
